module.exports = __webpack_public_path__ + "static/media/rolex_logo.8b6c956b.svg";